<div class="jumbotron" style="background-image: url('/assets/images/mw-home-banner.png'); background-size: cover; height: 500px;">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-4 pt-5">
        <h1 class="text-white">Home to Australia’s greatest selection of rare & fine wines.</h1>
        <div class="pt-4">
          <a class="btn btn-primary btn-red" [routerLink]="['/register']">Create an account</a>
        </div>
        <div class="pt-1">
          <small class="text-white">Already have an account? <a [routerLink]="['/login']">Login here</a></small>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="content-container">
  <!-- ROW 1 -->
  <div class="container">
    <div class="row tile-row">
      <div class="col-12 col-lg-5 m-y-auto">
        <div>
          <h3>MW Wines established as an independent wine auction house specialising in old and rare fine wines in Brunswick, Victoria.</h3>
          <p class="pt-4">Interested in purchasing or selling wine?</p>
          <div class="pt-4">
            <a class="btn btn-primary btn-red" [routerLink]="['/register']">Create an account</a>
          </div>
          <div class="pt-1">
            <small class="">Already have an account? <a [routerLink]="['/login']">Login here</a></small>
          </div>
        </div>
      </div>
      <div class="d-none d-lg-block offset-lg-3 col-lg-4 text-right">
        <img src="/assets/images/home-row-1.png" height="550">
      </div>
    </div>
    <!-- /ROW 1 -->

    <!-- ROW 2-->
    <div class="row tile-row">
      <div class="d-none d-lg-block col-lg-4">
        <img src="/assets/images/home-row-2.png" style="max-width:100%;">
      </div>
      <div class="col-12 offset-lg-2 col-lg-5 m-y-auto">
        <div>
          <h3>We run monthly online auctions with Australian and French wine of all price ranges.</h3>
          <div class="pt-4">
            <a class="btn btn-primary btn-red" [routerLink]="['/auction']">View this month’s auction</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /ROW 2 -->

  <!-- BANNER 2 -->
  <div class="jumbotron" style="background-image: url('/assets/images/mw-home-banner-2.png'); background-size: cover; height: 500px;">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-4 pt-5">
          <div class="message-container">
            <h3 class="border-bottom-red">Sell your wine</h3>
            <p class="pt-5">As the largest independent specialist wine auction house in Australia, ...</p>
            <div class="pt-4">
              <a class="btn btn-primary btn-red" [routerLink]="['/']">Learn more about selling</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /BANNER 2 -->

  <!-- BOTTOM TILES -->
  <div class="container tile-container">
    <div class="row title-row">

      <!-- TILE 1 -->
      <div class="col-12 col-md-4">
        <a class="card tile-card" [routerLink]="['/auctions']">
          <img class="card-img-top" src="/assets/images/tile-1.png" alt="">
          <h3 class="link-text text-white text-center w-100">Purchase wine</h3>
        </a>
      </div>
      <!-- TILE 1 -->

      <!-- TILE 2 -->
      <div class="col-12 col-md-4">
        <a class="card tile-card" [routerLink]="['/auctions']">
          <img class="card-img-top" src="/assets/images/tile-2.png" alt="">
          <h3 class="link-text text-white text-center w-100">Sell your wine</h3>
        </a>
      </div>
      <!-- /TILE 2 -->

      <!-- TILE 3 -->
      <div class="col-12 col-md-4">
        <a class="card tile-card" [routerLink]="['/register']">
          <img class="card-img-top" src="/assets/images/tile-3.png" alt="">
          <h3 class="link-text text-white text-center w-100">Register an account</h3>
        </a>
      </div>
      <!-- /TILE 3 -->

    </div>
  </div>
  <!-- /BOTTOM TILES -->

</div>
